import React from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import './MiniPopup.scss';
import warningIcon from '../../assets/images/errorFilledOrange.svg';
import errorIcon from '../../assets/images/errorFilledRed.svg';
import { PrimaryButton, SecondaryButton } from '../Buttons';

const MiniPopup = ({ type = 'Warning', mainMsg, subMsg, onConfirm, onCancel }) => {
    const { t } = useTranslation(['labels']);
    const icon = type === 'Error' ? errorIcon : warningIcon;

    return (
        <Dialog
            visible
            modal
            showHeader={false}
            className={`mini-popup mini-popup--${type.toLowerCase()}`}
        >
            <div className="mini-popup__content">
                <img src={icon} alt={type} className="mini-popup__icon" />
                <p className="mini-popup__main-msg">{mainMsg}</p>
                {subMsg && <p className="mini-popup__sub-msg">{subMsg}</p>}
            </div>
            <div className="mini-popup__footer">
                <SecondaryButton label={t('COMMON.NO')} onClick={onCancel} />
                <PrimaryButton label={t('COMMON.YES')} onClick={onConfirm} />
            </div>
        </Dialog>
    );
};

export default MiniPopup;
